import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';

const Homepage = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>AdvoCall Professional - Sofortige Rechtsberatung per Telefon | 24/7 verfügbar</title>
        <meta 
          name="description" 
          content="Professionelle Rechtsberatung per Telefon - 24/7 verfügbar. Transparente Preise ab 2,99 €/Min. Sofortige Hilfe von zertifizierten Anwälten. Jetzt anrufen!" 
        />
        <meta name="keywords" content="Rechtsberatung, Telefon, Anwalt, 24/7, sofort, günstig, transparent, AdvoCall" />
        <meta property="og:title" content="AdvoCall Professional - Sofortige Rechtsberatung per Telefon" />
        <meta property="og:description" content="Professionelle Rechtsberatung per Telefon - 24/7 verfügbar. Transparente Preise ab 2,99 €/Min." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://advocall.de/homepage" />
        <link rel="canonical" href="https://advocall.de/homepage" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LegalService",
            "name": "AdvoCall Professional",
            "description": "Professionelle Rechtsberatung per Telefon - 24/7 verfügbar",
            "url": "https://advocall.de",
            "telephone": "+49-xxx-xxxxxxx",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Kurfürstendamm 14",
              "postalCode": "10719",
              "addressLocality": "Berlin",
              "addressCountry": "DE"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "1500"
            },
            "priceRange": "€€",
            "availableLanguage": "German"
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="relative">
          {/* Hero Section - Emergency-focused landing with dual-action hero */}
          <HeroSection />
          
          {/* Stats Section - Trust building through animated statistics */}
          <StatsSection />
          
          {/* Services Section - Legal expertise showcase with practice areas */}
          <ServicesSection />
          
          {/* Process Section - How it works explanation */}
          <ProcessSection />
          
          {/* CTA Section - Final conversion with dual contact methods */}
          <CTASection />
        </main>

        {/* Accessibility Skip Link */}
        <a 
          href="#main-content" 
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-white px-4 py-2 rounded-lg z-50"
        >
          Zum Hauptinhalt springen
        </a>
      </div>
    </>
  );
};

export default Homepage;